export default __webpack_public_path__ + "static/media/tt.f2a8c711.svg";